module.exports = "/assets/800cbd434ea7465f8eda781c53b44bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/QI.png
// module id = 2875
// module chunks = 0